import React from 'react';

/* --bg-raised blocks at the EXACT dimensions of the content they replace. NO
   SHIMMER. First load of a surface only, and NEVER over an existing value — a
   stale number you can see is safer than a skeleton hiding one. */

export function Skeleton({ width = '100%', height = 16, radius = 'var(--radius-control)', count = 1, gap = 8, style }) {
  const one = (i) => (
    <div key={i} aria-hidden="true" style={{
      width: typeof width === 'number' ? width + 'px' : width,
      height: typeof height === 'number' ? height + 'px' : height,
      background: 'var(--bg-raised)', borderRadius: radius,
    }} />
  );
  if (count === 1) return <div style={style}>{one(0)}</div>;
  return <div style={{ display: 'flex', flexDirection: 'column', gap, ...style }}>{Array.from({ length: count }, (_, i) => one(i))}</div>;
}
